import { OneReachApp } from '../../../types';

/** TODO: Use OneReach Apps SDK? */
export const useAppsIntegrationAPI = () => {
  const BASE_URL = 'https://em.qa.api.onereach.ai/http/03db4abe-0477-47c0-ae4e-4c68f1047d59/2042';

  const getOneReachApp = async (args: { appId: string; token: string; }) => {
    const url = `${BASE_URL}/app?id=${args.appId}`;
    const headers = { Authorization: args.token };

    const response = await fetch(url, { headers });
    const json = await response.json();

    if (response.ok) {
      return json as OneReachApp;
    } else {
      throw json;
    }
  };

  const getOneReachAppQRCodeURL = (args: { appId: string; }) => {
    return `${BASE_URL}/app/qr?id=${args.appId}&darkColor=000000`;
  };

  const getOneReachAppQRCode = async (args: {
    appId: string;
    token: string;
  }) => {
    const url = `${BASE_URL}/app/qr?id=${args.appId}&darkColor=000000`;
    const headers = { Authorization: args.token };
    const response = await fetch(url, { headers });

    if (response.ok) {
      const text = await response.text();
      return text as string;
    } else {
      throw await response.json();
    }
  };

  const createOrUpdateOneReachApp = async (args: {
    type: 'create' | 'update';
    app?: OneReachApp;
    token: string;
  }) => {
    const { app = {}, token, type = 'create' } = args;
    const url = `${BASE_URL}/app`;
    const headers = { Authorization: token, 'Content-Type': 'application/json' };
    const method = type === 'create' ? 'POST' : 'PATCH';

    const body = JSON.stringify(app);
    const response = await fetch(url, { method, headers, body });
    const json = await response.json();

    if (response.ok) {
      return json as OneReachApp;
    } else {
      throw json;
    }
  };

  const deleteOneReachApp = async (args: { appId: string; token: string; }) => {
    const { appId, token } = args;
    const url = `${BASE_URL}/app?id=${appId}`;
    const headers = { Authorization: token, 'Content-Type': 'application/json' };

    const response = await fetch(url, { method: 'DELETE', headers });
    if (!response.ok) {
      const json = await response.json();
      throw json;
    }
  };

  return {
    getOneReachApp,
    getOneReachAppQRCodeURL,
    getOneReachAppQRCode,
    createOrUpdateOneReachApp,
    deleteOneReachApp,
  };
};
